import styled, { css } from 'styled-components';
import { absFull } from 'helpers/styles.js';
import collapse from 'images/icons/collapse.svg';
import sendWhite from 'images/icons/send_white.svg';
import globeWhite from 'images/icons/globeWhite.svg';
import saveWhite from 'images/icons/saveWhite.svg';

export const ModalContainer = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  text-align: center;
  z-index: 20;
`;


export const ModalBackdrop = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: all .3s  ease;
`;

export const ModalContent = styled.div`
  background: white;
  color: #585858;
  z-index: 21;
  position: relative;
  border-radius: 4px;
`;

export const EyeIcon = styled.div`
  position: absolute;
  top: 25px;
  right: 25px;
  width: 50px;
  background: ${({ theme: { colors } }) => colors.palette[7]} url(${collapse});
  height: 50px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 14px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
`;

export const ContentPopupContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  padding: 8px;
  height: 100%;
  transition: none;

  ${({ withTransition }) => withTransition && css`
    transition: all .4s ease;
  `};

  ${({ isOpen }) => isOpen && css`
    top: 7% !important;
    left: 50% !important;
    height: 86% !important;
    z-index: 1000;
    margin-left: -400px !important;
    width: 800px !important;

    @media(min-width: 1000px) {
      margin-left: -450px !important;
      width: 900px !important;
    }
    @media(min-width: 1200px) {
      margin-left: -550px !important;
      width: 1100px !important;
    }

    @media(min-width: 1300px) {
      margin-left: -600px !important;
      width: 1200px !important;
    }

    @media(min-width: 1500px) {
      margin-left: -700px !important;
      width: 1400px !important;
    }

    &:before {
      opacity: 1;
    }
  `};
`;

export const ContentScreenshotModal = styled.div`
  position: absolute;
  z-index: 5;
  width: 100%;
  height: 100%;
  transition: none;
  padding: 8px;
  margin-left: -400px !important;
  width: 800px !important;
  left: 50%;
  top: 10% !important;
  height: 90% !important;
  padding: 0;
  box-shadow: 0px 4px 15px 0 rgba(0, 0, 0, 0.4);
  overflow: hidden;
  border-radius: 40px;
  opacity: 0;
  transform: translate3d(0, 10%, 0);
  will-change: transform;
  transition: all .4s ease;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  @media(min-width: 1000px) {
    margin-left: -450px !important;
    width: 900px !important;
  }
  @media(min-width: 1200px) {
    margin-left: -550px !important;
    width: 1100px !important;
  }

  @media(min-width: 1300px) {
    margin-left: -600px !important;
    width: 1200px !important;
  }

  @media(min-width: 1500px) {
    margin-left: -700px !important;
    width: 1400px !important;
  }

  ${({ isOpen }) => isOpen && css`
    opacity: 1;
  transform: translate3d(0, 0, 0);
  `}
`;

export const ContentScreenshotContainer = styled.div`
  ${absFull()};
  position: fixed;
  z-index: -1;

  ${({ isOpen }) => isOpen && css`
    z-index: 1001;
  `}
`;

export const ContentScreenshotImg = styled.img`
  width: 100%;
  margin: auto;
  height: auto;
`;

export const ContentPopup = styled.div`
  ${absFull('8px', '18px', '8px', '18px')};
  background: ${({ theme }) => theme.colors.palette[0]};
  border-radius: 25px;
  overflow: hidden;
  opacity: ${({ open }) => open ? 1 : 0};
  transition: all .3s ease;
`;

export const PopupScrollContainer = styled.div`
  ${absFull()};
  overflow: scroll;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
  -webkit-transition: opacity 0.5s;
  transition: opacity 0.5s;
  pointer-events: none;
  opacity: 0;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: -34px;
  right: 18px;
  bottom: auto;
  left: auto;
  height: 44px;
  line-height: 15px;
  color: white;
  font-size: 23px;
  vertical-align: top;
  text-decoration: none;
  cursor: pointer;
  font-weight: 100;
`;

export const ModalButtons = styled.div`
  ${absFull('-24px', 'auto', 'auto', '18px')};
  text-align: left;
`;

export const ShareModalButton = styled.div`
  background: url('${sendWhite}') no-repeat;
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 24px;
  cursor: pointer;
  transition: all .1s ease;
  background-size: contain;
  opacity: 0.8;

  &:hover {
    transform: scale(1.05);
    opacity: 1;
  }
`;

export const ViewModalButton = styled.div`
  background: url('${globeWhite}') no-repeat;
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 24px;
  cursor: pointer;
  transition: all .1s ease;
  background-size: contain;
  opacity: 0.8;

  &:hover {
    transform: scale(1.05);
    opacity: 1;
  }
`;

export const BookmarkModalButton = styled.div`
  background: url('${saveWhite}') no-repeat;
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 24px;
  cursor: pointer;
  transition: all .1s ease;
  background-size: contain;
  opacity: 0.8;

  &:hover {
    transform: scale(1.05);
    opacity: 1;
  }

  ${({ active }) => active && css`
    transform: scale(1.05);
    opacity: 1;
  `}
`;

